// extracted by mini-css-extract-plugin
export var back = "SectionUnderdogPromotedDogs-module--back--ba9ef";
export var bordersection = "SectionUnderdogPromotedDogs-module--bordersection--0086e";
export var bordertop = "SectionUnderdogPromotedDogs-module--bordertop--b3990";
export var buttonwrapper = "SectionUnderdogPromotedDogs-module--buttonwrapper--c89e1";
export var curvedborder = "SectionUnderdogPromotedDogs-module--curvedborder--62ac3";
export var introtext = "SectionUnderdogPromotedDogs-module--introtext--85167";
export var navbuttons = "SectionUnderdogPromotedDogs-module--navbuttons--95615";
export var next = "SectionUnderdogPromotedDogs-module--next--c89f0";
export var spotlightdogsinner = "SectionUnderdogPromotedDogs-module--spotlightdogsinner--0d103";
export var swiper = "SectionUnderdogPromotedDogs-module--swiper--713c2";
export var swiperwrapper = "SectionUnderdogPromotedDogs-module--swiperwrapper--8d560";
export var title = "SectionUnderdogPromotedDogs-module--title--3e167 headings-module--sectionHeading--a8f67";
export var titlewrapper = "SectionUnderdogPromotedDogs-module--titlewrapper--ac389";